<div class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="addressModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <form [formGroup]="userProfileForm">
                <div class="modal-header">
                    <h3 class="modal-title" id="addressModalLabel">Shipping Address</h3>
                    <button type="button" class="close" aria-label="Close" (click)="close()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div><!-- End .modal-header -->

                <div class="modal-body">
                    <div class="form-group required-field">
                        <label>First Name </label>
                        <input type="text" class="form-control form-control-sm" formControlName="FirstName"
                            maxlength="50">
                        <span class="invalid-feedback"
                            *ngIf="userProfileForm.controls['FirstName'].errors?.required && (userProfileForm.controls['FirstName'].dirty || userProfileForm.controls['FirstName'].touched)">
                            Please enter First Name</span>
                    </div><!-- End .form-group -->

                    <div class="form-group required-field">
                        <label>Last Name </label>
                        <input type="text" class="form-control form-control-sm" formControlName="LastName"
                            maxlength="50">
                        <span class="invalid-feedback"
                            *ngIf="userProfileForm.controls['LastName'].errors?.required && (userProfileForm.controls['LastName'].dirty || userProfileForm.controls['LastName'].touched)">
                            Please enter Last Name</span>
                    </div><!-- End .form-group -->
                    <div class="form-group required-field">
                        <label for="address">Address </label>
                        <textarea name="" class="form-control customer-address" rows="3" id="address"
                            formControlName="Address" maxlength="200"></textarea>
                        <span class="invalid-feedback"
                            *ngIf="userProfileForm.controls['Address'].errors?.required && (userProfileForm.controls['Address'].dirty || userProfileForm.controls['Address'].touched)">
                            Please enter Address</span>
                    </div><!-- End .form-group -->

                    <div class="form-group required-field">
                        <label>City </label>
                        <input type="text" class="form-control form-control-sm" formControlName="CityName"
                            maxlength="50">
                        <span class="invalid-feedback"
                            *ngIf="userProfileForm.controls['CityName'].errors?.required && (userProfileForm.controls['CityName'].dirty || userProfileForm.controls['CityName'].touched)">
                            Please enter City</span>
                    </div><!-- End .form-group -->

                    <div class="form-group">
                        <label>State/Province</label>
                        <input type="text" class="form-control form-control-sm" formControlName="ProvincesName"
                            maxlength="50">
                        <span class="invalid-feedback"
                            *ngIf="userProfileForm.controls['ProvincesName'].errors?.required && (userProfileForm.controls['ProvincesName'].dirty || userProfileForm.controls['ProvincesName'].touched)">
                            Please enter State/Province</span>
                    </div><!-- End .form-group -->

                    <div class="form-group required-field">
                        <label>Zip/Postal Code </label>
                        <!-- <p-inputMask formControlName="PostalCode"
                            mask="999999"></p-inputMask> -->
                        <input type="text" class="form-control form-control-sm" formControlName="PostalCode"
                            maxlength="50">
                        <span class="invalid-feedback"
                            *ngIf="userProfileForm.controls['PostalCode'].errors?.required && (userProfileForm.controls['PostalCode'].dirty || userProfileForm.controls['PostalCode'].touched)">
                            Please enter Zip/Postal Code</span>
                    </div><!-- End .form-group -->

                    <div class="form-group">
                        <label>Country</label>
                        <input type="text" class="form-control form-control-sm" formControlName="CountryName"
                            maxlength="50">
                        <span class="invalid-feedback"
                            *ngIf="userProfileForm.controls['CountryName'].errors?.required && (userProfileForm.controls['CountryName'].dirty || userProfileForm.controls['CountryName'].touched)">
                            Please enter Country</span>
                    </div><!-- End .form-group -->

                    <div class="form-group required-field">
                        <label>Phone Number </label>
                        <div class="form-control-tooltip">
                            <p-inputMask formControlName="PhoneNo" mask="(999) 999-9999" [unmask]="unmask">
                            </p-inputMask>
                            <span class="input-tooltip" data-toggle="tooltip" title="For delivery questions."
                                data-placement="right"><i class="icon-question-circle"></i></span>
                        </div><!-- End .form-control-tooltip -->
                        <span class="invalid-feedback"
                            *ngIf="userProfileForm.controls['PhoneNo'].errors?.required && (userProfileForm.controls['PhoneNo'].dirty || userProfileForm.controls['PhoneNo'].touched)">
                            Please enter Phone Number</span>
                    </div><!-- End .form-group -->
                    <app-message [message]='message' *ngIf="message">
                    </app-message>
                </div><!-- End .modal-body -->

                <div class="modal-footer">
                    <button type="button" class="btn btn-link btn-sm" (click)="close() ">Cancel</button>
                    <button type="submit" class="btn btn-primary btn-sm" (click)="saveProfile()">Save changes</button>
                </div><!-- End .modal-footer -->
            </form>
        </div><!-- End .modal-content -->
    </div><!-- End .modal-dialog -->
</div><!-- End .modal -->